import { createFileRoute } from "@tanstack/react-router";
import { IncentivesPage } from "../pages/incentives";

export const Route = createFileRoute("/")({
  component: () => <IncentivesPage />,
});
